import { API_VERSIONS } from 'const';

const isApiV2 = apiVersion => apiVersion === API_VERSIONS.v2;

export { API_VERSIONS, isApiV2 };
